import { useQuery } from '@tanstack/react-query';
import { getMyRequest } from './httpCalls';
import { enqueueSnackbar } from 'notistack';

// Normalize { requests: {...} | null } to the array shape consumers expect.
// Kept at module level so react-query memoizes the result between renders.
const toRequestsArray = (resp) => ({
  ...resp,
  data: {
    ...resp?.data,
    requests: resp?.data?.requests ? [resp.data.requests] : [],
  },
});

// userId/scope only key the cache; GET /requests/me identifies the user by JWT.
export function useGetMyRequest({ userId, scope, enabled = true } = {}) {
  return useQuery({
    queryFn: () => getMyRequest(),
    queryKey: ['getMyRequest', userId, scope],
    enabled: enabled && Boolean(userId),
    select: toRequestsArray,
    onSuccess: () => {
      enqueueSnackbar('Επιτυχία!', {
        variant: 'success',
        autoHideDuration: 2000,
      });
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.message || 'Κάτι πήγε στραβά', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    },
  });
}
